<template>
  <v-text-field
    :disabled="disabled"
    :hint="hint"
    :rules="ruleList.concat(alphaValidationRule)"
    outlined
    v-model="value"
  ></v-text-field>
</template>

<script>
import formElementMixin from "./formElementMixin";

export default {
  data() {
    return {
      alphaValidationRule: [
        v => /^[a-zA-Z]*$/.test(v) || "Must contain only letters.",
      ],
    };
  },
  mixins: [formElementMixin],
  props: {
    hint: {
      type: String,
    },
  },
};
</script>
